// extracted by mini-css-extract-plugin
export default {"searchClassName":"style_searchClassName__Nwxr0"};